import { useContext } from 'react';
import { VerticalNavContext } from '../contexts/VerticalNavContext';

export const useVerticalNav = () => {
    const context = useContext(VerticalNavContext);
    if (!context) {
        throw new Error('useVerticalNav must be used within VerticalNavProvider');
    }
    return context;
};
